import { render, staticRenderFns } from "./BHPOrder.vue?vue&type=template&id=cfbfd5d6&scoped=true"
import script from "./BHPOrder.vue?vue&type=script&lang=js"
export * from "./BHPOrder.vue?vue&type=script&lang=js"
import style0 from "./BHPOrder.vue?vue&type=style&index=0&id=cfbfd5d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbfd5d6",
  null
  
)

export default component.exports